import { useState } from 'react';
import throttle from 'lodash/throttle';
import { useEvent, useIsomorphicLayoutEffect } from 'react-use';

export const SCROLL_DIRECTIONS = {
  DOWN: 'down',
  UP: 'up',
};

const useScrollDirection = () => {
  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollDirection, setScrollDirection] = useState();
  const [scrollY, setScrollY] = useState(0);

  const getPageScroll = () => {
    setScrollY(window.pageYOffset);
  };

  const onScroll = throttle(getPageScroll, 500);

  useEvent('scroll', onScroll);

  useIsomorphicLayoutEffect(() => {
    const scrollDirection = scrollY > lastScrollY ? SCROLL_DIRECTIONS.DOWN : SCROLL_DIRECTIONS.UP;

    setScrollDirection(scrollDirection);
    setLastScrollY(scrollY);
  }, [scrollY]);

  return scrollDirection;
};

export default useScrollDirection;
